module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom",
    attrs: {
      "id": "model"
    }
  }, [_c('div', {
    staticClass: "main-container",
    on: {
      "click": function($event) {
        _vm.$store.state.common.isbottomMenuOpen = false
      }
    }
  }, [_c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "12.315270935960589vh",
      "right": "16px"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "padding-right": "6px",
      "padding-bottom": "26px"
    }
  }, [_c('div', [_c('v-btn', {
    staticClass: "top-btn",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.share()
      }
    }
  }, [(_vm.os === 'iOS' || _vm.desktop === 'mac') ? _c('img', {
    staticStyle: {
      "height": "16px"
    },
    attrs: {
      "src": "https://png.icons8.com/ios/96/2d35cd/upload.png"
    }
  }) : _c('v-icon', {
    staticStyle: {
      "color": "#2d35cd"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v("\n                share\n              ")])], 1)], 1), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "top-btn",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/settings')
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#2d35cd"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v("settings")])], 1)], 1), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "top-btn",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.goToProfile('Person')
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#2d35cd"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v("person")])], 1)], 1), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "top-btn",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.goToProfile('Check-ins')
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#2d35cd"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v("location_on")])], 1)], 1), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "top-btn",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.goToProfile('Wishlist')
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#2d35cd"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v("favorite")])], 1)], 1), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "top-btn",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "white"
    },
    on: {
      "click": _vm.goToUpload
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#2d35cd"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add_a_photo")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-right": "26px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [(_vm.screenW < 600) ? _c('v-btn', {
    staticClass: "top-btn",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.goToHome(true)
      }
    }
  }, [_c('v-icon', {
    style: (("color: " + (_vm.selectedMode === 'Fullscreen' ? '#febd35' : '#2d35cd'))),
    attrs: {
      "dark": ""
    }
  }, [_vm._v("zoom_out_map")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "top-btn",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.goToHome(null)
      }
    }
  }, [_c('v-icon', {
    style: (("color: " + (_vm.selectedMode === 'Map' ? '#febd35' : '#2d35cd'))),
    attrs: {
      "dark": ""
    }
  }, [_vm._v("map")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "top-btn",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.goToHome(false)
      }
    }
  }, [_c('v-icon', {
    style: (("color: " + (_vm.selectedMode === 'List' ? '#febd35' : '#2d35cd'))),
    attrs: {
      "dark": ""
    }
  }, [_vm._v("view_day")])], 1)], 1)]), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "top-btn",
    staticStyle: {
      "background": "#2d35cd",
      "height": "60px",
      "width": "60px",
      "margin-right": "15px"
    },
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("clear")])], 1)], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aea0327","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/bottomMenu.vue
// module id = 523
// module chunks = 17